import React from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "reactflow";

import { ReactComponent as Trash } from "../../icons/trash.svg";

import "./buttonedge.css";

export default function CustomEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	style = {},
	markerEnd,
	data,
}) {
	const [edgePath, labelX, labelY] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
		// Stub horizontal mais longo ao sair do handle (print #22, ponto 2): as
		// saídas que voltam (p/ cima/baixo/esquerda) ganham um trecho horizontal
		// maior no Y de cada uma antes de empilhar na vertical, ficando clicáveis
		// individualmente. Default do reactflow é 20.
		offset: 40,
	});

	const onEdgeClick = (evt, id) => {
		evt.stopPropagation();

		data?.setEdges((edges) => edges.filter((ed) => ed.id !== id));
	};

	return (
		<>
			<BaseEdge
				path={edgePath}
				markerEnd={markerEnd}
				/* área de clique do fio (print #22, ponto 2): 20px (padrão do
				   reactflow) p/ dar pra clicar o fio na faixa à direita das saídas.
				   Em repouso os edges ficam abaixo dos nós, então essa área não
				   rouba cliques dos cards. */
				interactionWidth={20}
				style={{
					strokeWidth: 2,
				}}
			/>
			<EdgeLabelRenderer>
				<div
					data-line-action={id}
					id={id}
					style={{
						position: "absolute",
						transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
						fontSize: 12,
						display: "none",
						pointerEvents: "all",
					}}
					className="nodrag nopan"
				>
					<button
						className="edgebutton"
						title="Remover conexão"
						onClick={(event) => onEdgeClick(event, id)}
					>
						<Trash />
					</button>
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
